import '.g{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.i{justify-content:center;}.ssr-plugin'
import '.h{flex-direction:column;}.ssr-plugin'
import '.cn{background:var(--shades-white);}.ssr-plugin'
import '.bo{flex-grow:1;}.ssr-plugin'
import '.b{align-items:center;}.ssr-plugin'
import '.b6{max-width:77.5rem;}.ssr-plugin'
import '.di{justify-content:stretch;}.ssr-plugin'
import '.dj{position:sticky;}.ssr-plugin'
import '.cf{top:0;}.ssr-plugin'
import '.dk{z-index:10;}.ssr-plugin'
import '.dl{padding-block:1rem;}.ssr-plugin'
import '.dm{height:3rem;}.ssr-plugin'
import '.u{justify-content:space-between;}.ssr-plugin'
import '.dn{flex-wrap:wrap;}.ssr-plugin'
import '.do{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bl{margin-top:2rem;}.ssr-plugin'
import '.dp{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="g ab i h cn"
      >
        <div className="bo g b i h"
        >
          <div className="b6 g h di dj cf dk cn"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="dl dm g u b dn"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="do g h ab bl dp b6"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
